import React, { Component, useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import ButtonTable from "../common/table/buttonTable";
import Button from "../common/button/button";
import Form from "./contratoAluguelForm";
import Select from "../common/form/select";
import { DisplayPDF } from "../displayPDF/displayPDF";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import { getUcValidarUsuarioImplantacao } from "../cliente/clienteActions";
import { adicionarBloqueioUsuarioImplantacao } from "../utils/adicionarBloqueioUsuarioImplantacao";
import {
    setModoTela,
    initForm,
    setFiltro,
    salvar,
    excluir,
    getLista,
    getListaCliente,
    getListaUnidadeConsumidora,
    getListaTipoCustoGestaoContratoAluguel,
    buscarArquivoContrato,
} from "./contratoAluguelActions";
import { Loading } from "../common/loading/loading";
import FormatUtils from "../common/formatUtils/FormatUtils";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import { LabelSelectUcIconeGestor } from "../common/form/LabelSelectUcIconeGestor";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";

function ContratoAluguel(props) {
    //Sem acesso
    if (!props.usuarioLogado || props.usuarioLogado.acesso_cliente) {
        return <div />;
    }

    const [state, setState] = useState({
        exibirModalGestorConcessionaria: false,
        itemSelecionado: null,
    });

    useEffect(() => {
        props.getUcValidarUsuarioImplantacao();
        props.getListaCliente();
        props.getListaUnidadeConsumidora();
        props.getListaTipoCustoGestaoContratoAluguel();
        props.getLista();
    }, []);

    useEffect(() => {
        props.getLista();
    }, [props.filtro]);

    if (props.pdf) {
        return <DisplayPDF closePdf={() => props.setArquivoPDF()} pdfBase64={props.pdf} nomePdf={props.nomePdf} />;
    }
    return (
        <div>
            {props.aguardando ? <Loading /> : null}

            <Content>
                {props.modoTela === "visualizacao" && <Form onSubmit={() => {}} visualizacao />}
                {props.modoTela === "cadastro" && <Form onSubmit={props.salvar} />}
                {props.modoTela === "exclusao" && <Form excluir onSubmit={props.excluir} />}
                {props.modoTela === "lista" && lista()}
            </Content>
        </div>
    );

    function lista() {
        return (
            <ContentCard>
                <ModalGestorConcessonaria
                    visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_energia}
                    itemSelecionado={state.itemSelecionado}
                    handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                />
                <ContentCardHeader>
                    <Row>
                        <Grid cols="6 6 4 2">
                            <Button
                                text="Adicionar"
                                type={"success"}
                                icon={"fa fa-plus"}
                                disabled={!props.usuarioLogado.acesso_contrato_aluguel_adicionar}
                                event={() => {
                                    const novoContrato = {};
                                    props.setModoTela("cadastro", { ...novoContrato });
                                    props.initForm({ ...novoContrato });
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody>
                    <Row>
                        <Select
                            name="id_cliente"
                            options={props.listaCliente.filter(
                                (cliente) => props.usuarioLogado && props.usuarioLogado.administrador && props.lista.find((contrato) => contrato.id_cliente === cliente.id)
                            )}
                            label="Cliente"
                            cols="12 6 4"
                            placeholder="Selecione o Cliente"
                            isClearable={true}
                            value={props.filtro.id_cliente}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_cliente: value,
                                    id_unidade_consumidora: null,
                                });
                            }}
                        />
                        <Select
                            name="id_unidade_consumidora"
                            isClearable={true}
                            options={[
                                { id: 0, valor: "Usina Externa - Fonte Não Informada" },
                                ...props.listaUnidadeConsumidora.filter(
                                    (item) =>
                                        (!props.filtro.id_cliente || item.id_cliente == props.filtro.id_cliente) &&
                                        props.lista.find((contrato) => contrato.id_unidade_geradora === item.id)
                                ),
                            ]}
                            label={
                                <LabelSelectUcIconeGestor
                                    text="Unidade Geradora"
                                    filtro={props.filtro}
                                    listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                                    setExibirModal={(ucFiltro) =>
                                        setState({
                                            ...state,
                                            exibirModalGestorConcessionaria: true,
                                            itemSelecionado: ucFiltro,
                                        })
                                    }
                                />
                            }
                            cols="12 6 4"
                            placeholder="Selecione a UC"
                            value={props.filtro.id_unidade_consumidora}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_unidade_consumidora: value,
                                });
                            }}
                        />
                    </Row>

                    <Table responsive>
                        <THead>
                            <NewTr rowSpanBotoes={2} backgroundColorTr={"#F5F5F5"}>
                                <Th backgroundColor={"#F5F5F5"} rowSpan={2} verticalAlign="middle" minWidth={200} sticky>
                                    Cliente
                                </Th>
                                <Th backgroundColor={"#F5F5F5"} rowSpan={2} alignCenter verticalAlign="middle" minWidth={200} sticky>
                                    UC Geradora
                                </Th>
                                <Th backgroundColor={"#F5F5F5"} rowSpan={2} alignCenter verticalAlign="middle" minWidth={200} sticky>
                                    UCs Remotas
                                </Th>
                                <Th backgroundColor={"#F5F5F5"} colSpan={7} minWidth={100} sticky alignCenter>
                                    Contratos Vigentes
                                </Th>
                            </NewTr>
                            <NewTr rowSpanBotoes={0}>
                                <Th backgroundColor={"#F5F5F5"} minWidth={100} sticky top={44} alignCenter>
                                    Tipo de Análise
                                </Th>
                                <Th backgroundColor={"#F5F5F5"} minWidth={100} sticky top={44} alignCenter>
                                    Início da Vigência
                                </Th>
                                <Th backgroundColor={"#F5F5F5"} minWidth={100} sticky top={44} alignCenter>
                                    Fim da Vigência
                                </Th>
                                <Th backgroundColor={"#F5F5F5"} minWidth={100} sticky top={44} alignCenter>
                                    Valor Mensal do Aluguel
                                </Th>
                                <Th backgroundColor={"#F5F5F5"} minWidth={100} sticky top={44} alignCenter>
                                    Qtd. de Energia Contratada Anual
                                </Th>
                                <Th backgroundColor={"#F5F5F5"} minWidth={100} sticky top={44} alignCenter>
                                    Contrato
                                </Th>
                                <Th backgroundColor={"#F5F5F5"} minWidth={100} sticky top={44} alignCenter>
                                    Assume Custo da Fatura da Geradora
                                </Th>
                            </NewTr>
                        </THead>
                        <TBody>
                            {props.lista.map((item) => {
                                const contratosVigentes = item.contratos.filter((cv) => !cv.encerrado);
                                return (
                                    <NewTr
                                        key={item.id}
                                        botoes={[
                                            {
                                                type: "primary",
                                                icon: "fas fa-eye",
                                                disabled: !props.usuarioLogado.acesso_contrato_aluguel_visualizar,
                                                event: () => {
                                                    props.initForm(item);
                                                    props.setModoTela("visualizacao");
                                                },
                                            },
                                            {
                                                type: "warning",
                                                icon: "fas fa-pencil-alt",
                                                disabled: !props.usuarioLogado.acesso_contrato_aluguel_editar || item.bloquearEdicaoUsuarioImplantacao,
                                                event: () => {
                                                    props.initForm(item);
                                                    props.setModoTela("cadastro");
                                                },
                                            },
                                            {
                                                type: "danger",
                                                icon: "fas fa-trash-alt",
                                                disabled: !props.usuarioLogado.acesso_contrato_aluguel_editar || item.bloquearEdicaoUsuarioImplantacao,
                                                event: () => {
                                                    props.initForm(item);
                                                    props.setModoTela("exclusao");
                                                },
                                            },
                                        ]}
                                    >
                                        <Td>{item.nome_cliente}</Td>
                                        <Td alignCenter>{item.nome_unidade_geradora}</Td>
                                        <Td alignCenter>
                                            <ul style={{ padding: 20 }}>
                                                {item.ids_unidades_remotas.map((rem) => (
                                                    <li style={{ textAlign: "left" }}>{rem.label}</li>
                                                ))}
                                            </ul>
                                        </Td>
                                        <Td backgroundColor={"#F5F5F5"} alignCenter>
                                            {contratosVigentes.length
                                                ? contratosVigentes.map((cv, i, lista) => (
                                                      <div
                                                          style={{
                                                              borderInline: "1px solid #d5d5d5",
                                                              borderTop: "1px solid #d5d5d5",
                                                              borderBottom: i == lista.length - 1 ? "1px solid #d5d5d5" : "none",
                                                              padding: 3,
                                                              backgroundColor: cv.id_grupo_contrato_aluguel ? "#4169e1" : "#fffbb3",
                                                              color: cv.id_grupo_contrato_aluguel ? "#ffffff" : "#000000",
                                                          }}
                                                      >
                                                          {cv.id_grupo_contrato_aluguel ? (
                                                              <div>
                                                                  <div>Compartilhada</div>
                                                                  <div>({cv.nome_grupo_contrato_aluguel})</div>
                                                              </div>
                                                          ) : (
                                                              "Simples"
                                                          )}
                                                      </div>
                                                  ))
                                                : " - "}
                                        </Td>
                                        <Td backgroundColor={"#F5F5F5"} alignCenter>
                                            {contratosVigentes.length
                                                ? contratosVigentes.map((cv) => (
                                                      <div>{cv.competencia_inicio_vigencia ? FormatUtils.formatarCompetenciaTela(cv.competencia_inicio_vigencia) : " - "}</div>
                                                  ))
                                                : " - "}
                                        </Td>
                                        <Td backgroundColor={"#F5F5F5"} alignCenter>
                                            {contratosVigentes.length
                                                ? contratosVigentes.map((cv) => (
                                                      <div>{cv.competencia_fim_vigencia ? FormatUtils.formatarCompetenciaTela(cv.competencia_fim_vigencia) : " - "}</div>
                                                  ))
                                                : " - "}
                                        </Td>
                                        <Td backgroundColor={"#F5F5F5"} alignCenter>
                                            {contratosVigentes.length
                                                ? contratosVigentes.map((cv) => <div>{cv.valor_mensal_aluguel ? adicionarPontosMilhar(cv.valor_mensal_aluguel) : " - "}</div>)
                                                : " - "}
                                        </Td>
                                        <Td backgroundColor={"#F5F5F5"} alignCenter>
                                            {contratosVigentes.length
                                                ? contratosVigentes.map((cv) => (
                                                      <div>{cv.quantidade_energia_contratada_anual ? adicionarPontosMilhar(cv.quantidade_energia_contratada_anual) : " - "}</div>
                                                  ))
                                                : " - "}
                                        </Td>
                                        <Td backgroundColor={"#F5F5F5"} alignCenter minWidth={50}>
                                            {contratosVigentes.length
                                                ? contratosVigentes.map((cv) => (
                                                      <div>
                                                          {cv.arquivo_contrato ? (
                                                              <ButtonTable
                                                                  title="Visualizar"
                                                                  type={"primary"}
                                                                  icon={"fas fa-file-pdf"}
                                                                  visible={true}
                                                                  disabled={!props.usuarioLogado.acesso_contrato_aluguel_visualizar}
                                                                  event={() => {
                                                                      props.buscarArquivoContrato({
                                                                          id: cv.id,
                                                                          nome: `Contrato de Aluguel de Usina`,
                                                                      });
                                                                      props.setArquivoPDF();
                                                                  }}
                                                              />
                                                          ) : (
                                                              " - "
                                                          )}
                                                      </div>
                                                  ))
                                                : " - "}
                                        </Td>
                                        <Td backgroundColor={"#F5F5F5"} alignCenter>
                                            {contratosVigentes.length
                                                ? contratosVigentes.map((cv) => (
                                                      <div>
                                                          <i
                                                              style={{ fontSize: "1rem" }}
                                                              className={`far fa-${cv.assume_custo_fatura_usina_geradora ? "check-square" : "square"}`}
                                                          />
                                                      </div>
                                                  ))
                                                : " - "}
                                        </Td>
                                    </NewTr>
                                );
                            })}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }
}

const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.contratoAluguel.modoTela,
    formularioValues: getFormValues("contratoAluguelForm")(state),
    aguardando: state.contratoAluguel.aguardando,
    filtro: state.contratoAluguel.filtro,
    lista: adicionarBloqueioUsuarioImplantacao(state.auth.usuarioLogado, state.cliente.listaUcValidarUsuarioImplantacao, state.contratoAluguel.lista),
    listaCliente: state.contratoAluguel.listaCliente,
    listaUnidadeConsumidora: state.contratoAluguel.listaUnidadeConsumidora,
    pdf: state.displayPDF.pdf,
    nomePdf: state.displayPDF.nomePdf,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            setArquivoPDF,
            initForm,
            setFiltro,
            salvar,
            excluir,
            getLista,
            getListaCliente,
            getListaUnidadeConsumidora,
            getListaTipoCustoGestaoContratoAluguel,
            getUcValidarUsuarioImplantacao,
            buscarArquivoContrato,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(ContratoAluguel);
